/**
 * @generated SignedSource<<f116213772d3d88f04d2a8fa27c8b61a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isArchived"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offerIds"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "isArchived",
        "variableName": "isArchived"
      },
      {
        "kind": "Variable",
        "name": "offerIds",
        "variableName": "offerIds"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "setArchiveStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SetArchiveStatusOffersMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SetArchiveStatusOffersMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "620b0ac52933fc6691f0689a9073540a",
    "id": null,
    "metadata": {},
    "name": "SetArchiveStatusOffersMutation",
    "operationKind": "mutation",
    "text": "mutation SetArchiveStatusOffersMutation(\n  $offerIds: [ID!]!\n  $isArchived: Boolean!\n) {\n  setArchiveStatus(offerIds: $offerIds, isArchived: $isArchived) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "2e9e0be60c24490b7683bfda8c67f5e9";

export default node;
